import React from 'react';
import { FiPlus, FiEdit, FiTrash2, FiShield } from 'react-icons/fi';
import Button from '../common/Button';

const SYSTEM_ROLES = ['super_admin', 'admin', 'user'];

function RolesTab({
  roles,
  permissions,
  loading,
  onRefresh,
  onAddRole,
  onEditRole,
  onDeleteRole,
}) {
  // Only show the full-tab splash on first load (no roles yet). On refresh,
  // keep the existing list visible and rely on RefreshButton's own spinner —
  // otherwise the whole tab (including the button) gets replaced by the
  // splash and re-appears, which feels broken.
  const initialLoading = loading && (!roles || roles.length === 0);

  return (
    <div>
      {/* Title + Refresh now live in AdminDashboardPage's top header. */}
      <div className="flex items-center justify-end mb-4">
        <Button onClick={onAddRole} leftIcon={<FiPlus />}>
          Add Role
        </Button>
      </div>

      {initialLoading ? (
        <div className="text-center py-20 text-[#7a7060]">
          <div className="animate-pulse">Loading roles…</div>
        </div>
      ) : (
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
        {roles.map((role) => (
          <div
            key={role._id}
            className="bg-white rounded-[12px] border p-4 transition-all duration-200 hover:-translate-y-[2px]"
            style={{ borderColor: '#ddd6c6', boxShadow: '0 2px 16px rgba(8,17,31,.07)' }}
            onMouseEnter={(e) => { e.currentTarget.style.boxShadow = '0 6px 24px rgba(20,95,95,.12)'; }}
            onMouseLeave={(e) => { e.currentTarget.style.boxShadow = '0 2px 16px rgba(8,17,31,.07)'; }}
          >
            <div className="flex items-start justify-between mb-3">
              <div className="flex items-center gap-2">
                <div className="w-7 h-7 rounded-lg flex items-center justify-center" style={{ background: '#145f5f14' }}>
                  <FiShield className="text-[#145f5f] text-[13px]" />
                </div>
                <div>
                  <h3 className="text-[15px] font-bold text-[#08111f]">{role.displayName || role.name}</h3>
                  <p className="text-[11px] text-[#7a7060]">@{role.name}</p>
                </div>
              </div>
            </div>

            <p className="text-[11px] text-[#7a7060] mb-3">{role.description || 'No description'}</p>

            <div className="mb-3">
              <div className="text-[10px] font-semibold text-[#08111f] mb-2">Permissions ({role.permissions?.length || 0}):</div>
              <div className="flex flex-wrap gap-1">
                {role.permissions?.slice(0, 5).map((p, i) => (
                  <span key={i} className="px-2 py-0.5 rounded-full text-[9px] font-semibold text-[#145f5f]" style={{ background: '#145f5f22' }}>
                    {p.displayName || p.name || String(p).replace(/_/g, ' ')}
                  </span>
                ))}
                {role.permissions?.length > 5 && (
                  <span className="px-2 py-0.5 rounded-full text-[9px] font-semibold text-[#7a7060]" style={{ background: '#f0ebe0' }}>
                    +{role.permissions.length - 5} more
                  </span>
                )}
              </div>
            </div>

            <div className="flex items-center justify-between">
              <span className={`px-2 py-0.5 rounded-full text-[10px] font-semibold ${role.isActive !== false ? 'bg-[#e8efe5] text-[#4a6b3f]' : 'bg-[#f2e9e6] text-[#9a564a]'}`}>
                {role.isActive !== false ? 'Active' : 'Inactive'}
              </span>
              <div className="flex items-center gap-1">
                <Button variant="outline" size="sm" leftIcon={<FiEdit />} onClick={() => onEditRole(role)}>
                  Edit
                </Button>
                {!SYSTEM_ROLES.includes(role.name) && onDeleteRole && (
                  <Button variant="outline" size="sm" iconOnly title="Delete" onClick={() => onDeleteRole(role._id)}>
                    <FiTrash2 style={{ color: '#9a564a' }} />
                  </Button>
                )}
              </div>
            </div>
          </div>
        ))}

        {roles.length === 0 && (
          <div className="col-span-full text-center py-12 text-[#7a7060]">No roles configured</div>
        )}
      </div>
      )}
    </div>
  );
}

export default RolesTab;
